import { HttpResponse, http } from "msw";
import { PlessService } from "../../../app/shared/pless-service.model";

export const kymw75Handlers = [
  http.post(
    PlessService.SERVICE.getPlanGoodsFeature.url,
    () => {
        return HttpResponse.json(getPlanGoodsFeature);
    }
  ),
  http.post<unknown, { data: { parameter: { PCode: string; }; }; }>(
    PlessService.SERVICE.getGoodsListForCheckPlanNum.url,
    async ({ request }) => {
      const pCode = (await request.json()).data.parameter?.PCode;
      if (pCode) {
        return HttpResponse.json(getSpecificGoods(pCode));
      }
      return HttpResponse.json(getGoodsListForCheckPlanNum);
    }
  ),
  http.post(
    PlessService.SERVICE.updateCheckPlanNum.url,
    () => {
      return HttpResponse.json({ status: 'ok', message: '処理完了' });
    }
  ),
  http.post(
    PlessService.SERVICE.kymw75GetCatalogInfo.url,
    () => {
      return HttpResponse.json(getCatalogInfo);
    }
  )
];


const getPlanGoodsFeature = {
  status: 'ok',
  message: '処理完了',
  result: {
    obj: [
      {
        FeatureCode: "001H1",
        FeatureName: "表紙"
      },
      {
        FeatureCode: "00101",
        FeatureName: "特集１"
      },
      {
        FeatureCode: "001H2",
        FeatureName: "裏表紙"
      },
    ]
  }
};

const getSpecificGoods = (pCode: string) => ({
  status: 'ok',
  message: '処理完了',
  result: {
    obj: [{
      OrderCode: '2023300',
      MediumType: '001',
      CheckFlag: '0',
      PredictPlanNum: '12345',
      PlanNum: '12345',
      PredictDiff: '0',
      SupplyPrice: '5000',
      FeatureCode: '001H1',
      FeatureName: '表紙',
      PCode: pCode,
      GoodsGuideName: '商品名１',
      GoodsStandardName: '企画名1',
      PricePattern: '通常価',
      PricePromotion: '005',
      PricePromotionName: 'スーパープライス',
      AppearDiv: '1',
      AppearDivName: '新登場',
      KomaPromotion: '02',
      KomaPromotionName: '2コマ',
      PromotionMark: '093',
      PromotionMarkName: 'エコマーク',
      ThisTimeSupplyPrice: '2000',
      ThisTimeCostPrice: '3000',
    }]
  }
});

const getGoodsListForCheckPlanNum = {
  status: 'ok',
  message: '処理完了',
  result: {
    obj: [...[...Array(20)].map((v, i) => {
      const PredictPlanNum = (Math.ceil(Math.random() * 9) * 10000000).toString();
      const PlanNum = (Math.ceil(Math.random() * 9) * 10000000).toString();
      const PredictDiff = (Number(PredictPlanNum) - Number(PlanNum)).toString();
      const CheckFlag = i % 2 === 0 ? '0' : '1';
      const PCode = `P${String(1338900 + i).padStart(7, '0')}`;
      return {
          OrderCode: '2023300',
          MediumType: '001',
          CheckFlag,
          PredictPlanNum,
          PlanNum,
          PredictDiff,
          SupplyPrice: '5000',
          FeatureCode: '001H1',
          FeatureName: '表紙',
          PCode,
          GoodsGuideName: '商品名１',
          GoodsStandardName: '企画名1',
          PricePattern: '通常価',
          PricePromotion: '005',
          PricePromotionName: 'スーパープライス',
          AppearDiv: '1',
          AppearDivName: '新登場',
          KomaPromotion: '02',
          KomaPromotionName: '2コマ',
          PromotionMark: '093',
          PromotionMarkName: 'エコマーク',
          ThisTimeSupplyPrice: '2000',
          ThisTimeCostPrice: '3000',
        };
      }),
      {
        OrderCode: '2023300',
        MediumType: '001',
        CheckFlag: '0',
        PredictPlanNum: null,
        PlanNum: null,
        PredictDiff: null,
        SupplyPrice: null,
        FeatureCode: null,
        FeatureName: null,
        PCode: 'P9999999',
        GoodsGuideName: '商品名１',
        GoodsStandardName: '企画名1',
        PricePattern: null,
        PricePromotion: null,
        PricePromotionName: null,
        AppearDiv: null,
        AppearDivName: null,
        KomaPromotion: null,
        KomaPromotionName: null,
        PromotionMark: null,
        PromotionMarkName: null,
        ThisTimeSupplyPrice: null,
        ThisTimeCostPrice: null,
      },
      {
        OrderCode: '2023300',
        MediumType: '001',
        CheckFlag: false,
        PredictPlanNum: '0',
        PlanNum: '0',
        PredictDiff: '0',
        SupplyPrice: '5000',
        FeatureCode: '001H1',
        FeatureName: '表紙',
        PCode: 'P1234567',
        GoodsGuideName: '商品名１<>﨑☻✨',
        GoodsStandardName: '企画名1<>﨑☻✨',
        PricePattern: '通常価<>﨑☻✨',
        PricePromotion: '005',
        PricePromotionName: 'スーパープライス<>﨑☻✨',
        AppearDiv: '1',
        AppearDivName: '新登場<>﨑☻✨',
        KomaPromotion: '02',
        KomaPromotionName: '2コマ<>﨑☻✨',
        PromotionMark: '093',
        PromotionMarkName: 'エコマーク<>﨑☻✨',
        ThisTimeSupplyPrice: '2000',
        ThisTimeCostPrice: '3000',
      }
    ]
  }
};

const getCatalogInfo = {
  status: 'ok',
  message: '処理完了',
  result: {
    obj:{
      ProgressWorkNum: '08'
    },
  }
};